/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
    PersonaToJSONTyped,
} from './Persona';

/**
 * 
 * @export
 * @interface ChatChannelEvent
 */
export interface ChatChannelEvent {
    /**
     * Unique identifier of the chat channel event
     * @type {string}
     * @memberof ChatChannelEvent
     */
    id: string;
    /**
     * The persona associated with this event, if any
     * @type {Persona}
     * @memberof ChatChannelEvent
     */
    persona?: Persona;
    /**
     * The type of event that occurred
     * @type {string}
     * @memberof ChatChannelEvent
     */
    type: ChatChannelEventTypeEnum;
    /**
     * Additional event data payload
     * @type {string}
     * @memberof ChatChannelEvent
     */
    data: string;
    /**
     * The time this event was created
     * @type {Date}
     * @memberof ChatChannelEvent
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ChatChannelEventTypeEnum = {
    ChannelCreated: 'CHANNEL_CREATED',
    ChannelNameUpdated: 'CHANNEL_NAME_UPDATED',
    ChannelStatusUpdated: 'CHANNEL_STATUS_UPDATED',
    ChannelResolutionUpdated: 'CHANNEL_RESOLUTION_UPDATED',
    ChannelCreatedEmailSent: 'CHANNEL_CREATED_EMAIL_SENT',
    ChannelUnreadMessageEmailSent: 'CHANNEL_UNREAD_MESSAGE_EMAIL_SENT',
    Message: 'MESSAGE',
    UserJoin: 'USER_JOIN',
    UserLeave: 'USER_LEAVE',
    PresenceUpdate: 'PRESENCE_UPDATE',
    ParticipantUpdated: 'PARTICIPANT_UPDATED',
    PrivateNote: 'PRIVATE_NOTE'
} as const;
export type ChatChannelEventTypeEnum = typeof ChatChannelEventTypeEnum[keyof typeof ChatChannelEventTypeEnum];


/**
 * Check if a given object implements the ChatChannelEvent interface.
 */
export function instanceOfChatChannelEvent(value: object): value is ChatChannelEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ChatChannelEventFromJSON(json: any): ChatChannelEvent {
    return ChatChannelEventFromJSONTyped(json, false);
}

export function ChatChannelEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannelEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'persona': json['persona'] == null ? undefined : PersonaFromJSON(json['persona']),
        'type': json['type'],
        'data': json['data'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ChatChannelEventToJSON(json: any): ChatChannelEvent {
    return ChatChannelEventToJSONTyped(json, false);
}

export function ChatChannelEventToJSONTyped(value?: ChatChannelEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'persona': PersonaToJSON(value['persona']),
        'type': value['type'],
        'data': value['data'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

